import { render, staticRenderFns } from "./OfficeEdit.vue?vue&type=template&id=a01e5688&scoped=true"
import script from "./OfficeEdit.vue?vue&type=script&lang=js"
export * from "./OfficeEdit.vue?vue&type=script&lang=js"
import style0 from "./OfficeEdit.vue?vue&type=style&index=0&id=a01e5688&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a01e5688",
  null
  
)

export default component.exports